export default {
	INPUTERROR: '輸入資訊有錯誤',
	NOTCOMPLETED: '帳號或密碼未填寫完整',
	ENTRANOTCONFIGURED: '尚未設定 Microsoft Entra ID',
	LOGINFAILED: '登入失敗，請稍後再試',
	LOGOUTFAILED: 'Microsoft 登出失敗，請稍後再試',
	CHOOSESVID: '請選擇一份問卷',
	STARTANSWER: '開始填答',
	NOWORKNO: '此車號沒有工單',
};



// WEBPACK FOOTER //
// ./src/js/wording.js